module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-gold.15a43160.png";